import React from 'react';

import { InventoryCard, ItemAchievement } from '.';
import { GameDocumentContext } from '../../../../../../contexts/game-document';
import { CastPlayerInventory } from '../../../../../../utils/game-engine/inventory';
import { PlayerContext } from '../../../../../../contexts/player';
import { BankResponse } from '../../../../../../types/responses/bank-response';
import { generateTitleById } from '../../../../../../utils/game-document/display-languages';
import { DisplayLanguageContext } from '../../../../../../contexts/display-languages';

export const PlayerInventory: React.FC<{
  bank: BankResponse | undefined;
  teamInventory?: boolean;
  setItemCard: React.Dispatch<
    React.SetStateAction<ItemAchievement | undefined>
  >;
}> = ({ bank, teamInventory, setItemCard }) => {
  const [gameDocument] = React.useContext(GameDocumentContext);
  const [playerState] = React.useContext(PlayerContext);
  const [displayLanguageContext] = React.useContext(DisplayLanguageContext);

  const preGameSetting = gameDocument.gameDocument?.settings.preGame;

  const playerInventory = React.useMemo(() => {
    return CastPlayerInventory(
      gameDocument.gameDocument!,
      playerState.playerState!
    );
  }, [playerState.playerState?.inventory]);

  return (
    <div
      className={'h-100 d-flex flex-column flex-grow-1 gap-3'}
      style={{
        minHeight: teamInventory ? '40%' : '100%',
        padding: '12px',
        borderRadius: '8px',
        backgroundColor: '#1C445F4D'
      }}>
      <h2 className={'m-0 fw-bold'}>
        {generateTitleById(
          'f90a1b2c-3d4e-5f6a-7b8c-9d0e1f2a3b4c',
          gameDocument,
          displayLanguageContext.displayLanguageSelected.resources!,
          'game'
        ) || 'Your Inventory'}
      </h2>

      <div
        className={'gap-3 h-100 d-flex flex-column flex-grow-1 overflow-auto'}>
        {(() => {
          const items = playerInventory
            .filter((item) => !item.hideInGame)
            .filter((item) => !item.bankItemGroupId);

          if (!items.length) return;
          return (
            <div className={'gap-2 d-flex flex-wrap'}>
              {items.map((item) => (
                <InventoryCard
                  key={item.id}
                  action={'return'}
                  item={item}
                  items={[]}
                  isTeamGame={preGameSetting?.isPreGameTeamRequired ?? false}
                  setItemCard={setItemCard}
                />
              ))}
            </div>
          );
        })()}

        {bank &&
          gameDocument.gameDocument?.assets.bankItemGroups?.map((group) => {
            const items = playerInventory.filter(
              (item) =>
                item.useBank &&
                !item.hideInGame &&
                item.bankItemGroupId === group.id
            );

            if (!items.length) return;
            return (
              <div className={'d-flex flex-column'} key={group.id}>
                <span
                  style={{
                    fontSize: '18px'
                  }}>
                  <b>{group.name}</b>
                </span>

                <div className={'gap-2 d-flex flex-wrap'}>
                  {items.map((item) => (
                    <InventoryCard
                      key={item.id}
                      item={item}
                      items={[]}
                      action={'return'}
                      isTeamGame={
                        preGameSetting?.isPreGameTeamRequired ?? false
                      }
                      setItemCard={setItemCard}
                    />
                  ))}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
